import { Card, Collapse } from '@mui/material'
import { memo, useCallback, useContext, useState } from 'react'
import CardActionsArea from './Card/CardActionsArea'
import CardContent from './Card/CardContent'
import CardActions from './Card/CardActions'
import CardHeader from './Card/CardHeader'
import { ProductListProps } from '../..'
import { ProductosVendedorContext } from '../../context/productos.vendedor.context'
import { TenantsContext } from '../../../../context/tenants.context'

interface MobileProductProps extends ProductListProps {
  product: any
}

export const getColor = (product: any) => {
  return product.aprobado && !product.pausado && !product.vencido
    ? '#b3faa8'
    : product.rechazado
    ? '#ffaeba'
    : product.pausado || product.vencido
    ? '#ddd'
    : '#fff'
}

const MobileProduct = ({
  product,
  isAdmin,
  loadingVideo,
  handleDeleteProduct,
  handleEditProduct,
  handlePauseProduct,
  handleResumeProduct
}: MobileProductProps) => {
  const { tenant } = useContext(TenantsContext)
  const { productosSeleccionados, setProductosSeleccionados } = useContext(ProductosVendedorContext)
  const [expanded, setExpanded] = useState(false)

  const handleActionAreaClick = useCallback(() => {
    handleEditProduct(product.codProducto, tenant)
  }, [product.codProducto, handleEditProduct])

  return (
    <Card
      onContextMenu={(e) => e.preventDefault()}
      sx={{
        width: 350,
        height: 'auto',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: 5,
        userSelect: 'none'
      }}
    >
      <CardActionsArea
        product={product}
        loadingVideo={loadingVideo}
        handleActionAreaClick={handleActionAreaClick}
        productosSeleccionados={productosSeleccionados}
        setProductosSeleccionados={setProductosSeleccionados}
      />

      <CardHeader expanded={expanded} product={product} setExpanded={setExpanded} />

      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent product={product} />
      </Collapse>

      <CardActions
        handleEditProduct={handleActionAreaClick}
        handleDeleteProduct={handleDeleteProduct}
        handlePauseProduct={handlePauseProduct}
        handleResumeProduct={handleResumeProduct}
        isAdmin={isAdmin}
        product={product}
      />
    </Card>
  )
}

export default memo(MobileProduct)
